import { Component, input, output } from '@angular/core';

// An error with a way to try again; what was loaded before stays visible below it.
@Component({
  selector: 'app-banner',
  templateUrl: './banner.html',
  styleUrl: './banner.css',
})
export class Banner {
  readonly heading = input.required<string>();
  readonly message = input.required<string>();
  readonly note = input('');
  readonly busy = input(false);

  readonly retry = output<void>();
}
